"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
function OptionCard({ children, label, description, onClick, }) {
    return ((0, jsx_runtime_1.jsxs)(react_1.Flex, Object.assign({ py: 3, px: 4, rounded: "md", shadow: "md", gap: 4, w: "full", alignItems: "center", _hover: { cursor: "pointer" }, onClick: onClick }, { children: [children, (0, jsx_runtime_1.jsxs)(react_1.Flex, Object.assign({ flexDir: "column", gap: 1 }, { children: [(0, jsx_runtime_1.jsx)(react_1.Box, { children: (0, jsx_runtime_1.jsx)(react_1.Text, Object.assign({ fontWeight: "medium" }, { children: label })) }), description ? (0, jsx_runtime_1.jsx)(react_1.Box, { children: description }) : null] }))] })));
}
exports.OptionCard = OptionCard;
